export enum Mode {
  Dark = 'dark',
  Light = 'light',
}
